import { DashboardListRow } from '../DashboardListRow'

import { BirdviewPortfolioRowMeta } from './BirdviewPortfolioRowMeta'

import BuildingIcon from '../../../icons/building.svg'

function BirdviewPortfolioRow({ Icon = BuildingIcon, item, onOpen }) {
  function handleOpen(event) {
    onOpen({ event, item })
  }

  return (
    <DashboardListRow
      Icon={Icon}
      Meta={BirdviewPortfolioRowMeta}
      metaProps={{ item }}
      title={item.title}
      onMouseDownTitle={handleOpen}
      onOpen={handleOpen}
    />
  )
}

export default BirdviewPortfolioRow
